import { gql } from "graphql-tag";

export const followUserGQL = gql`
  mutation followUser($userId: UUID!) {
    followUser(userId: $userId) {
      message
    }
  }
`;

export const unfollowUserGQL = gql`
  mutation unfollowUser($userId: UUID!) {
    unfollowUser(userId: $userId) {
      message
    }
  }
`;
